import { useState } from 'react';
import { ActionIcon, Box } from '@mantine/core';
import { NavSection, NavSectionProps } from 'components/navigation/nav-section/NavSection';
import { UserNavItem, UserNavItemProps } from 'components/navigation/user-nav-item/UserNavItem';
import { Logo } from 'components/logo/Logo';
import { ChevronRight } from 'icons/index';
import styles from './SideNav.module.css';

export type SideNavProps = {
    topSections: NavSectionProps[];
    bottomSections?: NavSectionProps[];
    userNavItemProps?: UserNavItemProps;
};

export const SideNav = ({ topSections, bottomSections, userNavItemProps }: SideNavProps) => {
    const [expanded, setExpanded] = useState(true);
    const showBottomDivider = (bottomSections?.length ?? 0) > 0 || userNavItemProps;

    return (
        <Box className={`${styles.sideNav} ${expanded ? styles.sideNavExpanded : styles.sideNavCollapsed}`}>
            <Box className={styles.logoSection}>
                <Box className={styles.logoContainer}>
                    <Logo size={expanded ? 'medium' : 'small'} color="white" />
                </Box>
                <ActionIcon
                    className={styles.toggleButton}
                    onClick={() => setExpanded(!expanded)}
                    aria-label="Toggle navigation bar"
                >
                    <ChevronRight />
                </ActionIcon>
            </Box>
            <Box className={styles.topSection} tabIndex={0}>
                {topSections.map((section, index) => (
                    <NavSection key={section.label ?? index} {...section} expanded={expanded} />
                ))}
            </Box>
            <Box>
                {showBottomDivider ? <Box className={styles.divider} /> : null}
                {bottomSections?.map((section, index) => (
                    <NavSection key={section.label ?? index} {...section} expanded={expanded} />
                ))}
                {userNavItemProps !== undefined ? (
                    <Box className={styles.userNavItemContainer}>
                        <UserNavItem {...userNavItemProps} isExpanded={expanded} />
                    </Box>
                ) : null}
            </Box>
        </Box>
    );
};
